import { Check } from 'lucide-react';

const Header = ({ visitDate, startTime, providerName }) => {
  const visitMeta = [startTime, providerName && `with ${providerName}`].filter(Boolean).join(' ');

  return (
    <div className="text-center">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-success-50">
        <Check size={30} strokeWidth={2.5} className="text-success-500" />
      </div>

      <h3 className="mt-4 text-xl font-bold text-secondary-900">
        You&apos;re confirmed{visitDate ? ` for ${visitDate}` : ''}
      </h3>
      <p className="mx-auto mt-1.5 max-w-sm text-sm leading-relaxed text-secondary-500">
        {visitMeta ? `${visitMeta} — we'll remind you by text and email.` : "We'll remind you by text and email."}
      </p>
    </div>
  );
};

export default Header;
